export default [
  {
    path: 'afiliados/afiliados-pendentes',
    name: 'afiliados-pendentes',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Painel',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Afiliados' },
      ]
    }
  },
]